import { RemoteParticipantReconnectingOverlay } from './RemoteParticipantReconnectingOverlay';
import { useRemoteParticipantReconnectingOverlay } from './useRemoteParticipantReconnectingOverlay';

export type RemoteParticipantReconnectingOverlayWrapperProps = {
  remoteParticipantIdentity: string;
};

export function RemoteParticipantReconnectingOverlayWrapper({
  remoteParticipantIdentity,
}: RemoteParticipantReconnectingOverlayWrapperProps) {
  const { shouldShow, ...props } = useRemoteParticipantReconnectingOverlay({
    remoteParticipantIdentity,
  });

  if (shouldShow) {
    return <RemoteParticipantReconnectingOverlay {...props} />;
  }
}
